exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1QSadAaaSItRkOIPihlSz6{margin-top:110px;margin-bottom:16px;color:#333}\n", ""]);

// Exports
exports.locals = {
	"MastheadEditor": "_1QSadAaaSItRkOIPihlSz6"
};